import instanceAxios from "./intanceAxios";


export const equipmentService = {
    getTypeEquipments: async (params) =>  await instanceAxios.get('/assets/type-equipment/', { params }),
    createTypeEquipment: async (data) => await instanceAxios.post('/assets/type-equipment/', data),
    createEquipment: async (data) => await instanceAxios.post('/assets/equipment/', data),
    updateEquipment: async (data) => await instanceAxios.put('/assets/equipment/', data),
    getEquipments: async (params) => await instanceAxios.get('/assets/equipment/', { params }),
    postMasiveEquipments: async (data) => await instanceAxios.post('/assets/equipment-masive/', data),
    deleteEquipments: async (ids) => await instanceAxios.delete('/assets/equipment-delete/', { data: { ids } }),
    getEquipmentByHash: async (hash) => await instanceAxios.get(`/assets/equipment-hash/${hash}/`)
}